import React from 'react';
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from "@material-ui/core/";

export default ({
    status,
    handleChangeStatus
}) => {
    return (
        <FormControl fullWidth>
            <InputLabel id="select-status-label">Status</InputLabel>
            <Select
                labelId="select-status-label"
                id="select-status"
                value={status}
                label="Status"
                onChange={handleChangeStatus}
            >
                <MenuItem value={"Todos"}>Todos</MenuItem>
                <MenuItem value={"Pendente"}>Pendente</MenuItem>
                <MenuItem value={"Aprovado"}>Aprovado</MenuItem>
            </Select>
        </FormControl>
    );
};